import React, { useState } from 'react';
import { Button, Flex, Modal, Spin, Tooltip, Typography } from "antd";
import { useForm } from "antd/lib/form/Form";
import { useTranslation } from "react-i18next";
import { useGetDataOnScroll } from "../../../../../components/getDataOnScrollProps/useGetDataOnScrollProps";
import _ from "lodash";
import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { EmptyData } from "../../../../../components/empty/emptyData";
import { EntTypesOfFertilizersFilter } from "../../../../../models/filters/typesOfFertilizersFilter";
import { EntTypesOfFertilizers } from "../../../../../models/handBooks/typesOfFertilizers";
import i18n from "i18next";
import {
  useLazyGetTypesOfFertilizersQuery
} from "../../../../../redux/api/handBooksApi/chemicalization/typesOfFertilizersApi";
import { PageHeader } from "../../../../../components/page-header";
import { ContentPartFilter } from "../../../../../components/content-part/ContentPartFilter";
import { useTypesOfFertilizers } from "./useTypesOfFertilizers";
import { FilterTypesOfFertilizers } from "./FilterTypesOfFertilizers";
import { AddTypesOfFertilizers } from "./AddTypesOfFertilizers";

enum FormField {
  name,
  categoryName
}

export const TypesOfFertilizers = () => {
  const [modal, contextHolder] = Modal.useModal();
  const [selectedItem, setSelectedItem] = useState<EntTypesOfFertilizers>(new EntTypesOfFertilizers());
  const [showModal, setShowModal] = useState<boolean>(false);
  const [form] = useForm();
  const { t } = useTranslation()

  const {
	onAddTypesOfFertilizers,
	onDeleteTypesOfFertilizers,
	onEditTypesOfFertilizers
  } = useTypesOfFertilizers(modal, () => {
	searchHandleClick();
  })
  const [height, setHeight] = useState<number>(0);

  const [getArchiveFolders] = useLazyGetTypesOfFertilizersQuery();

  const {
	filter,
	fetching,
	data,
	access,
	totalItems,
	setData,
	setFetching,
	setFilter,
	scrollHandler,
	setCurrentPage
  } = useGetDataOnScroll<EntTypesOfFertilizers, EntTypesOfFertilizersFilter>({
	initialFilter: new EntTypesOfFertilizersFilter(),
	query: getArchiveFolders
  });
  const openAddModal = (item: EntTypesOfFertilizers) => {
	setSelectedItem(item);
	setShowModal(true);
  };
  const setEntityFromFields = (): EntTypesOfFertilizersFilter => {
	let filt: EntTypesOfFertilizersFilter = _.clone(filter);
	filt.name = form.getFieldValue(FormField.name) ?? null;
	filt.categoryName = form.getFieldValue(FormField.categoryName) ?? null;
	filt.page = 1;
	return filt;
  }
  const clearFields = () => {
	form.setFields([
	  { name: FormField.name, value: null },
	  { name: FormField.categoryName, value: null },
	]);
  }

  const searchHandleClick = () => {
	setFilter(setEntityFromFields());
	setData([]);
	setCurrentPage(0);
	setFetching(true);
  }

  const table = (
	<div style={ { maxHeight: `${ height }px`, overflow: 'auto' } } onScroll={ scrollHandler }>
	  <table>
		<thead>
		<tr>
		  <th style={ { width: "40px" } }>#</th>
		  <th>{ t('general.nameKy') }</th>
		  <th>{ t('general.nameRu') }</th>
		  <th>{ t('handbooks.types_of_fertilizers.category_name') }</th>
		  <th style={ { width: "120px" } }></th>
		</tr>
		</thead>
		<tbody>
		{ fetching ? (
		  <tr>
			<th colSpan={ 7 }>
			  <Spin spinning={ fetching } style={ {
				width: '100%',
				height: '180px',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center'
			  } }/>
			</th>
		  </tr>
		) : null }
		{ data.length !== 0 ? data.map((item, index) => (
		  <tr key={ item.id }>
			<td>{ ++index }</td>
			<td>{ item?.nameKy }</td>
			<td>{ item?.nameRu }</td>
			<td>{ i18n.language === 'ru' ? item.fertilizerCategory?.nameRu : item.fertilizerCategory?.nameKy }</td>
			<td>
			  <Flex gap="small">
				{ access && access.methodPut && (
				  <Tooltip title={ t('general.edit') }>
					<Button className='btn_edit' onClick={ () => {
					  openAddModal(item)
					} } type="primary" shape="circle" icon={ <EditOutlined/> }/>
				  </Tooltip>
				) }
				{ access && access.methodDelete && (
				  <Tooltip title={ t('general.delete') }>
					<Button className='btn_edit' danger onClick={ () => {
					  onDeleteTypesOfFertilizers(item)
					} } type="primary" shape="circle" icon={ <DeleteOutlined/> }/>
				  </Tooltip>
				) }
			  </Flex>
			</td>
		  </tr>
		)) : (
		  <tr>
			<td colSpan={ 9 }>
			  <EmptyData/>
			</td>
		  </tr>
		) }
		</tbody>
	  </table>
	</div>
  );
  return (
	<>
	  <PageHeader
		title={ t('titles.types_of_fertilizers') }
		additionalInfo={
		  <Typography.Text style={ { marginBottom: '0.5em', display: 'block' } } type="secondary">
			{ t('handbooks.types_of_fertilizers.types_of_fertilizers_desc') } { t('general.records_found') } { totalItems }
		  </Typography.Text>
		}
	  />
	  { access && access.methodPost && (
		<Button type="primary" icon={ <PlusOutlined/> } onClick={ () => {
		  openAddModal(new EntTypesOfFertilizers())
		} }>
		  { t('general.add') }
		</Button>
	  ) }
	  <ContentPartFilter
		filter={ <FilterTypesOfFertilizers
		  onSearch={ searchHandleClick }
		  onReset={ () => {
			clearFields();
			searchHandleClick()
		  } }
		  formField={ FormField }
		  form={ form }
		/> }
		setHeight={ setHeight }
		table={ table }
	  />

	  <AddTypesOfFertilizers
		typesOfFertilizers={ selectedItem }
		show={ showModal }
		onHide={ () => {
		  setShowModal(false)
		} }
		onSubmit={ selectedItem.id !== null ? onEditTypesOfFertilizers : onAddTypesOfFertilizers }
	  />
	  { contextHolder }
	</>
  );
}
